import * as React from 'react';

const Translate = require('react-redux-i18n').Translate;

import { ContentWrapper, ContentButton, ButtonContainer } from '../styles';
import { NewStyleColor } from '../../../utils/styles-constants';
import { hexToRgba } from '../../../utils/style';
import Utils from '../../../utils';
import UserAgentUtils from '../../../utils/userAgent';

interface ContentProps {
	isPreparingContentStructure: boolean;
	contentStructureReady: boolean;
	needsContentStructureCompletion?: boolean;
	onRetryContentStructure?: () => void;
	contentStructureEverCompleted?: boolean;
	isReturnVisitOfflineInit?: boolean;
	isDownloadingRequiredItems?: boolean;
	isDownloadingThumbs?: boolean;
}

const Content = ({
	isPreparingContentStructure,
	contentStructureReady,
	needsContentStructureCompletion,
	onRetryContentStructure,
	contentStructureEverCompleted,
	isReturnVisitOfflineInit = false,
	isDownloadingRequiredItems = false,
	isDownloadingThumbs = false,
}: ContentProps) => {
	// When offline and content structure was never completed, show message with retry button
	if (needsContentStructureCompletion) {
		return (
			<ContentWrapper>
				<div className="icon-and-text">
					<Translate
						value="messages.content_structure_never_completed"
						dangerousHTML={true}
					/>
				</div>
				{UserAgentUtils.isOnline() && (
					<ButtonContainer>
						<ContentButton
							type="button"
							onClick={onRetryContentStructure}
							backgroundColor={hexToRgba(NewStyleColor.Blue50, 70)}
						>
							<Translate value="messages.retry" />
						</ContentButton>
					</ButtonContainer>
				)}
			</ContentWrapper>
		);
	}

	// When preparing content structure, show different messages for first time vs update
	if (isPreparingContentStructure) {
		const isFirstTime = !contentStructureEverCompleted;
		return (
			<ContentWrapper>
				<div className="icon-and-text">
					{Utils.getSvgIcon('iconset_loading')}
					<div className="text">
						<Translate
							value={isFirstTime ? 'messages.preparing_content_structure' : 'messages.updating_content_structure'}
							dangerousHTML={true}
						/>
						{isFirstTime && (
							<Translate
								value="messages.do_not_close_app"
								dangerousHTML={true}
							/>
						)}
					</div>
				</div>
			</ContentWrapper>
		);
	}

	// Required items can still be downloading after contentStructureReady is cleared (3s auto-hide).
	if (isDownloadingRequiredItems) {
		return (
			<ContentWrapper>
				<div className="icon-and-text">
					{Utils.getSvgIcon('iconset_loading')}
					<div className="text">
						<Translate
							value="messages.downloading_required_items_for_offline_use"
							dangerousHTML={true}
						/>
					</div>
				</div>
			</ContentWrapper>
		);
	}

	// Thumbnails can still be downloading after contentStructureReady is cleared.
	if (isDownloadingThumbs) {
		return (
			<ContentWrapper>
				<div className="icon-and-text">
					{Utils.getSvgIcon('iconset_loading')}
					<div className="text">
						<Translate
							value={isReturnVisitOfflineInit
								? 'messages.verifying_thumbnails_for_offline_use'
								: 'messages.downloading_thumbnails_for_offline_use'}
							dangerousHTML={true}
						/>
					</div>
				</div>
			</ContentWrapper>
		);
	}

	// When content structure is ready and both required items and thumbnails are done, show completion message
	if (contentStructureReady && !isDownloadingRequiredItems && !isDownloadingThumbs) {
		return (
			<ContentWrapper>
				<div className="icon-and-text">
					<Translate
						value="messages.content_structure_ready"
						dangerousHTML={true}
					/>
				</div>
			</ContentWrapper>
		);
	}

	// Fallback: if widget is displayed but no specific condition matches, show a default message
	// This should not happen in normal flow, but prevents empty widget display
	return null;
};

export default Content;









// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ContentStructureToast/Content/index.tsx